<template>
    <div class="right_container">
        <el-autocomplete class="inline-input" v-model="keyword" clearable :popper-append-to-body="false"
            :fetch-suggestions="querySearch" placeholder="输入关键词搜索" @input="handleSelect" :trigger-on-focus="false"
            @select="handleSelect">
            <template #prefix v-if="search">
                <i class="el-icon-search"></i>
            </template>
        </el-autocomplete>
        <!-- <i v-if="search" class="el-icon-search"></i> -->
        <div class="equipment1">
            设备编号：{{ user.imei }}
            <div class="boxRadius green" v-if="user.imeiState == 0">
                在线
            </div>
            <div class="boxRadius error" v-else>
                离线
            </div>
        </div>
        <div class="user_section" style="position: relative;">
            <img id="headimgurl" :class="showHide == 1 ? '' : 'headimgurl'" v-if="user.avatar"
                style="width: 100px;height: 110px;" :src="user.avatar" alt="">
            <img id="headimgurl" :class="showHide == 1 ? '' : 'headimgurl'" v-else src="../img/photo.png" alt="">
            <div id="user_card">
                <img :src="user.typeimg" alt="">
                <span>{{ user.typeshow }}</span>
            </div>

            <dl style="width: 70%;">
                <dt><img src="../img/icon1.png" alt=""> 使用者信息</dt>
                <dd>
                    <span>姓 名：{{ showHide == 1 ? user.name : user.names }}</span> 电话：{{ showHide == 1 ? user.tel :
                    user.tels}}
                    <img width="18" @click="editEyeShowHide(0)" v-if="showHide == 1" src="../img/show.png" alt="">
                    <img width="18" @click="handClickShowHide(1)" v-else src="../img/hide.png" alt="">
                </dd>
                <dd>过往病史：{{ user.bs }}</dd>
                <dd><span>紧急联系：{{ showHide == 1 ? user.jj_name : user.jj_names }}</span> 电话：{{ showHide == 1 ? user.jj_tel
                    :
                    user.jj_tels}} </dd>
            </dl>
            <dl>
                <dt><img src="../img/icon2.png" alt=""> 所属公司</dt>
                <dd><span>公司名称：{{ user.title }}</span>岗位：{{ user.gangwei }}</dd>
                <dd>工作时间：{{ user.gztime }}</dd>
            </dl>
            <dl>
                <dt><img src="../img/icon3.png" alt=""> 护航信息</dt>
                <dd style="margin-top: 32px;">
                    <img id="userimg" src="../img/user.png" alt="">
                    <div class="user_grade">
                        {{ fenshu }}
                        <br>
                        <span id="grade">总分数</span>
                    </div>
                    <img id="shu" src="../img/shu.png" alt="">
                    <div class="flex_gray">
                        <div class="child">
                            <div class="process">
                                <div v-bind:style="{ height: max + '%' }"></div>
                            </div>
                            <div class="process_cent">
                                <span>{{ max_xy }}</span>
                                <p>最高血压</p>
                            </div>
                        </div>
                        <div class="child" style="margin-top: 8px">
                            <div class="process">
                                <div v-bind:style="{ height: min + '%' }"></div>
                            </div>
                            <div class="process_cent">
                                <span>{{ min_xy }}</span>
                                <p>最低血压</p>
                            </div>
                        </div>
                    </div>
                </dd>
            </dl>
        </div>
        <ul class="three_section">
            <li>
                <div class="img">
                    <img class="iconimg" src="../img/tu1.png" :class="{ go: 'addRotate' }" @click='rotate' alt="">
                    <img class="icon_img" src="../img/tu11.png" alt="">
                </div>
                <div class="center-gray">
                    <div class="success font" style="color: #2AE77E;">{{ temp > 0 ? temp : '36' }}</div>
                    <div class="text-font">体温 <strong :class="beforeGoingToBed == '不正常' ? 'red' : 'green'">【{{
                        beforeGoingToBed
                            == '不正常' ? '异常' : '正常' }}】</strong></div>
                </div>
                <div class="nowEcharts charts" :style="{ height: '80px', width: '74%', margin: 0, padding: 0 }" ref="charta"
                    id="charta"></div>
            </li>
            <li>
                <div class="img">
                    <img class="iconimg" src="../img/tu2.png" :class="{ go: 'addRotate' }" @click='rotate'
                        style="border-radius: 50%;" alt="">
                    <img class="icon_img" style="left: 24%;" src="../img/tu22.png" alt="">
                </div>
                <div class="center-gray">
                    <div class="success font" style="color: #F37B26;">{{ ox > 0 ? ox : '94' }}</div>
                    <div class="text-font">血氧 <strong
                            :class="morningPeakHeartRate == '不正常' ? 'red' : 'green'">【{{ morningPeakHeartRate == '不正常' ?
                            '异常' :
                            '正常'}}】</strong></div>
                </div>
                <div class="nowEcharts charts" :style="{ height: '80px', width: '74%', margin: 0, padding: 0 }" ref="charta"
                    id="chartb"></div>
            </li>
            <li>
                <div class="img">
                    <img class="iconimg" src="../img/tu3.png" :class="{ go: 'addRotate' }" @click='rotate'
                        style="border-radius: 50%;" alt="">
                    <img class="icon_img" style="top: 30%;left: 21%;" src="../img/tu33.png" alt="">
                </div>
                <div class="center-gray">
                    <div class="success font" style="color: #FFBB17;">{{ heart > 0 ? heart : '72' }}</div>
                    <div class="text-font">心率 <strong
                            :class="bloodOxygenBeforeBedtime == '不正常' ? 'red' : 'green'">【{{ bloodOxygenBeforeBedtime ==
                            '不正常' ?
                            '异常' : '正常'}}】</strong></div>
                </div>
                <div class="nowEcharts charts" :style="{ height: '80px', width: '74%', margin: 0, padding: 0 }" ref="charta"
                    id="chartc"></div>
            </li>
        </ul>
        <div class="map-location">
            <i class="el-icon-map-location"></i>
            <span>所在位置：{{ user.address }}</span>
            <el-button v-if="mapState" @click="toHistory" style="padding: 7px 0;position: relative;top: -3px;"
                type="primary" size="mini">历史轨迹<i class="el-icon-arrow-right el-icon--right"></i></el-button>
        </div>
    </div>
</template>

<script>
import echarts from 'echarts'
export default {
    name: 'chartb',
    data() {
        return {
            mapState: false,
            temp: 0,
            ox: 0,
            heart: 0, // 心率
            max: 0,
            min: 0,
            fenshu: '00',
            max_xy: '00',
            min_xy: '00',

            search: true,
            restaurants: [],
            keyword: '',
            keywords: '',
            timeout: null,
            uname: '',
            user: {
                avatar: '',
                imei: '--',
                name: '--',
                names: '--',
                tel: '--',
                tels: '--',
                bs: '--',
                jj_name: '--',
                jj_tel: '--',
                jj_names: '--',
                jj_tels: '--',
                title: '--',
                address: '-------',
                gangwei: '--',
                gztime: '--',
                type: '--',
                imeiState: ''
            },
            showHide: 0,
            content: '',
            zx: '',
            lx: '',
            yc: '',
            company: '',
            beforeGoingToBed: '',
            morningPeakHeartRate: '',
            bloodOxygenBeforeBedtime: ''
        }
    },
    props: ['chartb'],
    mounted() {
        this.keyword = this.$route.query.keyword
        if (this.keyword) {
            this.search = false
        } else {
            this.search = true
        }

        this.restaurants = this.loadAll();

        // this.timers();
        // this.charta();
        // this.chartb();
        // this.chartc();
        // this.gethealthScore();
        setTimeout(() => {
            this.getUserShow();
            this.clickTimes()
        }, 800)
    },
    methods: {
        mapStateHand() {
            console.log("历史路径")
            this.mapState = true
        },
        rotate() {
            this.addRotate = true;
            setTimeout(() => {
                this.addRotate = false;
            }, 10000)
        },
        clickTimes() {
            this.timer = setInterval(() => {
                this.getUserShow();
                this.getArea()
                this.gethealthScore();
                this.bpList();
                setTimeout(() => {
                    this.charta();
                    this.chartbs();
                    this.chartc();
                }, 800)
            }, 10000)
        },

        handleSelect(i) {
            // console.log(i);
            if (!i) {
                this.search = true
            } else {
                this.search = false
            }
            this.keyword = i
            sessionStorage.setItem("keywords", i);
            this.getUserShow();
            this.getArea()
            this.gethealthScore();
            this.bpList();
            setTimeout(() => {
                this.charta();
                this.chartb();
                this.chartc();
            }, 800)
        },
        bpList(val) {
            var that = this

            if (that.keyword) {
                var deviceid = that.keyword
            } else {
                var deviceid = val
            }
            that.axios.get(this.$url.baseUrl + 'index/xueya?deviceid=' + deviceid, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                }
            })
                .then(function (res) {

                    if (res.data.code == 0) {

                        that.max_xy = res.data.data[0].systolic
                        that.min_xy = res.data.data[0].diastolic

                        that.max = 100 - (that.max_xy / 220 * 100)
                        that.min = 100 - (that.min_xy / 220 * 100)

                    } else {
                        that.max_xy = 0
                        that.min_xy = 0

                        that.max = 0
                        that.min = 0
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        handClickShowHide(i) {
            var that = this
            if (i == 1) {
                this.$prompt('请输入密码', '提示', {
                    inputType: 'password',
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                }).then(({ value }) => {
                    if (value == 'sxjxrhhhxt') {
                        that.editEyeShowHide(i);

                    } else {
                        this.$alert('<p>密码有误，请重新输入</p>', {
                            dangerouslyUseHTMLString: true
                        });
                    }
                }).catch(() => {
                    this.$alert('<p>取消输入</p>', {
                        dangerouslyUseHTMLString: true
                    });
                });
                return false
            }
        },
        editEyeShowHide(i) {
            var that = this
            console.log(i)
            that.showHide = parseInt(i)
            // console.log(that.showHide,"显示隐藏状态")

            that.axios.get(that.$url.baseUrl + 'index/saveconfig?value=' + i, {

            })
                .then(function (res) {
                    that.getUserShow();
                    that.getArea()
                    that.gethealthScore();
                    that.bpList();
                    setTimeout(() => {
                        that.charta();
                        that.chartbs();
                        that.chartc();
                    }, 800)
                    // that.getUserShows(that.keyword);
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        gethealthScore(val) {
            var that = this

            if (that.keyword) {
                var deviceid = that.keyword
            } else {
                var deviceid = val
            }
            that.axios.get(this.$url.baseUrl + 'index/jiankang?deviceid=' + deviceid, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                }
            })
                .then(function (res) {
                    // console.log(res.data,"分数")
                    if (res.data.code == 0 && res.data.data) {
                        that.fenshu = res.data.data.totalScore
                        // that.temp = res.data.data.temp
                        // that.ox = res.data.data.ox
                        // that.heart = res.data.data.heart
                        // that.beforeGoingToBed = res.data.data.beforeGoingToBed
                        // that.morningPeakHeartRate = res.data.data.morningPeakHeartRate
                        // that.bloodOxygenBeforeBedtime = res.data.data.bloodOxygenBeforeBedtime
                    } else {
                        that.fenshu = 0
                        // that.temp = 0
                        // that.ox = 0
                        // that.heart = 0
                        // that.beforeGoingToBed = "正常"
                        // that.morningPeakHeartRate = "正常"
                        // that.bloodOxygenBeforeBedtime = "正常"
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
        },

        getUserShows(i) {
            var that = this
            that.axios.get(this.$url.baseUrl + 'index/usershow?value=' + i, {
            })
                .then(function (res) {
                    if (res.data.code == 0) {
                        that.user = res.data.data

                        if (!res.data.data.address) {
                            that.getArea(res.data.data.imei)
                        }
                        that.keywords = res.data.data.imei
                        that.gethealthScore(res.data.data.imei);
                        that.bpList(res.data.data.imei);
                        that.showHide = parseInt(res.data.data.showhide)
                        // console.log(that.showHide,"是否显示状态")
                        setTimeout(() => {
                            that.charta(res.data.data.imei);
                            that.chartbs(res.data.data.imei);
                            that.chartc(res.data.data.imei);
                        }, 800)
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
        },

        getUserShow() {
            var that = this
            // console.log(that.keyword,"关键词关键词关键词关键词关键词")
            that.axios.get(this.$url.baseUrl + 'index/usershow?value=' + that.keyword, {
            })
                .then(function (res) {
                    if (res.data.code == 1) {
                        that.user = res.data.data

                        if (!res.data.data.address) {
                            that.getArea(res.data.data.imei)
                        }
                        that.keywords = res.data.data.imei
                        that.gethealthScore(res.data.data.imei);
                        that.bpList(res.data.data.imei);
                        that.showHide = parseInt(res.data.data.showhide)
                        // console.log(that.showHide,"是否显示状态")
                        setTimeout(() => {
                            that.charta(res.data.data.imei);
                            that.chartbs(res.data.data.imei);
                            that.chartc(res.data.data.imei);
                        }, 800)
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        getArea(val) {
            var that = this

            if (that.keyword) {
                var deviceid = that.keyword
            } else {
                var deviceid = val
            }
            that.axios.post(this.$url.baseUrl + 'index/getMap', {
                params: {
                    deviceid: deviceid,
                    pageSize: 10,
                    startime: '',
                    endtime: '',
                    status: '-1'
                }
            })
                .then(function (res) {
                    // console.log(res.data.data[0].address,"地址")
                    that.user.address = res.data.data[0].address

                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        loadAll() {
            return [];
        },
        querySearch(queryString, cb) {
            var restaurants = this.restaurants;
            var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
            // 调用 callback 返回建议列表的数据
            cb(results);
        },
        createFilter(queryString) {
            return (restaurant) => {
                return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
            };
        },

        charta(val) {
            var that = this

            if (that.keyword) {
                var deviceid = that.keyword
            } else {
                var deviceid = val
            }
            that.axios.get(this.$url.baseUrl + 'index/tiwen?deviceid=' + deviceid + '&pageSize=100', {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                }
            })
                .then(function (res) {

                    // console.log(res)
                    // console.log(res.data.templist)
                    // console.log(res.data.msg)
                    // console.log(that.temp)
                    // console.log(res.data.templist.length)


                    if (res.data.templist.length < 1) {
                        that.beforeGoingToBed = "正常"
                        // that.temp = 0;
                        res.data.templist = [36, 36.5, 36.2, 36.8, 36.6, 36, 36.7, 36.9, 36.8];
                    }

                    if (that.temp < 1 && res.data.templist.length > 0) {
                        that.temp = res.data.templist[0]
                        if (that.temp >= 36 && that.temp < 37) {
                            that.beforeGoingToBed = "正常"
                        } else {
                            that.beforeGoingToBed = "不正常"
                        }

                    }

                    // else{
                    // 	that.beforeGoingToBed = "不正常"
                    // 	that.temp = 0;
                    // }
                    // console.log(res.data.templist,"体温")

                    var chartDom = document.getElementById('charta');
                    var myChart = echarts.init(chartDom);
                    var option;

                    option = {
                        tooltip: {
                        },
                        xAxis: {
                            type: 'category',
                            splitLine: {
                                show: false,
                                lineStyle: {
                                    color: "#432D3F",
                                },
                            },
                            axisTick: {
                                show: false   //刻度线
                            },
                            axisLine: {
                                show: false,
                                lineStyle: {
                                    color: "#432D3F",
                                }
                            }
                        },
                        grid: {
                            show: false,
                            borderWidth: 0,
                        },
                        yAxis: {
                            type: 'value',
                            splitLine: {
                                show: false,
                                lineStyle: {
                                    color: "#432D3F",
                                },
                            },
                            axisLine: {
                                show: false,
                                lineStyle: {
                                    color: "#432D3F",
                                }
                            },
                            axisTick: {
                                show: false   //刻度线
                            },
                            nameTextStyle: {//y轴上方单位的颜色
                                color: '#fff'
                            },
                            axisLabel: {
                                show: false
                            },
                        },
                        series: [
                            {
                                lineStyle: {
                                    color: "#2AE77E",
                                },
                                data: res.data.templist,
                                type: 'line'
                            }
                        ]
                    };

                    option && myChart.setOption(option);
                })
                .catch(function (error) {
                    console.log(error);
                });

        },
        chartbs(val) {
            // console.log(this.$url.baseUrl+'index/xueyang');
            var that = this

            if (that.keyword) {
                var deviceid = that.keyword
            } else {
                var deviceid = val
            }
            // console.log(deviceid);
            that.axios.get(this.$url.baseUrl + 'index/xueyang?deviceid=' + deviceid + '&pageSize=100', {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                }
            })
                .then(function (res) {
                    // console.log(res);

                    // console.log(res)
                    // console.log(res.data.xylist)
                    // console.log(that.ox)
                    // console.log(res.data.xylist.length)

                    if (res.data.xylist.length < 1) {
                        that.morningPeakHeartRate = "正常"
                        // that.ox = 0
                    }

                    if (that.ox < 1 && res.data.xylist.length > 0) {
                        that.ox = res.data.xylist[res.data.xylist.length - 1]
                        if (that.ox >= 94 && that.ox <= 100) {
                            that.morningPeakHeartRate = "正常"
                        } else {
                            that.morningPeakHeartRate = "不正常"
                        }
                    }

                    // else{
                    // 	that.morningPeakHeartRate = "不正常"
                    // 	that.ox = 0
                    // }

                    var chartDom = document.getElementById('chartb');
                    var myChart = echarts.init(chartDom);
                    var option;

                    option = {
                        tooltip: {},
                        xAxis: {
                            type: 'category',
                            splitLine: {
                                show: false,
                                lineStyle: {
                                    color: "#432D3F",
                                },
                            },
                            axisTick: {
                                show: false   //刻度线
                            },
                            axisLine: {
                                show: false,
                                lineStyle: {
                                    color: "#432D3F",
                                }
                            }
                        },
                        grid: {
                            show: true,
                            borderWidth: 0,
                        },
                        // grid:{show:true,borderWidth:0},
                        yAxis: {
                            type: 'value',
                            splitLine: {
                                show: false,
                                lineStyle: {
                                    color: "#432D3F",
                                },
                            },
                            axisTick: {
                                show: false   //刻度线
                            },
                            axisLine: {
                                show: false,
                                lineStyle: {
                                    color: "#432D3F",
                                }
                            },
                            nameTextStyle: {//y轴上方单位的颜色
                                color: '#fff'
                            },
                            axisLabel: {
                                show: false
                            },
                        },
                        series: [
                            {
                                lineStyle: {
                                    color: "#F37B26",
                                },
                                data: res.data.xylist,
                                type: 'line'
                            }
                        ]
                    };

                    option && myChart.setOption(option);
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        chartc(val) {
            var that = this
            if (that.keyword) {
                var deviceid = that.keyword
            } else {
                var deviceid = val
            }
            that.axios.get(this.$url.baseUrl + 'index/xinlv?deviceid=' + deviceid + '&pageSize=100', {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                }
            })
                .then(function (res) {

                    // console.log(res)
                    // console.log(res.data.xllist[0])
                    // console.log(that.heart)
                    // console.log(res.data.xllist.length)

                    if (res.data.xllist.length < 1) {
                        that.bloodOxygenBeforeBedtime = "正常"
                        // that.heart = 0;
                    }

                    if (that.heart < 1 && res.data.xllist.length > 0) {
                        that.heart = res.data.xllist[res.data.xllist.length - 1];
                        if (that.heart >= 60) {
                            that.bloodOxygenBeforeBedtime = "正常"
                        } else {
                            that.bloodOxygenBeforeBedtime = "不正常"
                        }
                    }

                    // else{
                    // 	that.bloodOxygenBeforeBedtime = "不正常"
                    // 	that.heart = 0;
                    // }

                    var chartDom = document.getElementById('chartc');
                    var myChart = echarts.init(chartDom);
                    var option;

                    option = {
                        tooltip: {
                        },
                        xAxis: {
                            type: 'category',
                            splitLine: {
                                show: false,
                                lineStyle: {
                                    color: "#432D3F",
                                },
                            },
                            axisTick: {
                                show: false   //刻度线
                            },
                            axisLine: {
                                show: false,
                                lineStyle: {
                                    color: "#432D3F",
                                }
                            }
                        },
                        grid: {
                            show: true,
                            borderWidth: 0,
                        },
                        // grid:{show:true,borderWidth:0},
                        yAxis: {
                            type: 'value',
                            splitLine: {
                                show: false,
                                lineStyle: {
                                    color: "#432D3F",
                                },
                            },
                            axisTick: {
                                show: false   //刻度线
                            },
                            axisLine: {
                                show: false,
                                lineStyle: {
                                    color: "#432D3F",
                                }
                            },
                            nameTextStyle: {//y轴上方单位的颜色
                                color: '#fff'
                            },
                            axisLabel: {
                                show: false
                            },
                        },
                        series: [
                            {
                                lineStyle: {
                                    color: "#FFBB17",
                                },
                                data: res.data.xllist,
                                type: 'line'
                            }
                        ]
                    };

                    option && myChart.setOption(option);
                })
                .catch(function (error) {
                    console.log(error);
                });

        },
        toHistory() {
            this.$router.push('/index/history?keyword=' + this.keywords)
        }
    }
}
</script>

<style>
@keyframes rotate {
    0% {
        transform: (0deg)
    }

    100% {
        transform: (360deg)
    }
}

input:focus {
    border: 1px solid #DCDFE6;
}

.go {
    animate: rotate 1s;
}

#headimgurl {
    position: absolute;
    right: 0;
    top: 0;
}

.headimgurl {
    filter: blur(4px);
}

#user_card {
    display: inline-block;
    position: absolute;
    right: -6px;
    top: 116px;
}

#user_card span {
    position: absolute;
    display: inline-block;
    top: 3px;
    left: 28px;
    color: #07184a;
    font-size: 10px;
}

.equipment1 {
    color: #e3f0ff;
    font-size: 18px;
    font-weight: bold;
    margin: 12px 0;
}

.equipment1 .green {
    background-color: #02F5AD;
    font-size: 15px;
}

.equipment1 .error {
    background-color: #FE2828;
}
</style>



// WEBPACK FOOTER //
// src/components/Chartb.vue